module.exports = __webpack_public_path__ + "static/media/WBlogo.aaf755f0.svg";